import { Injectable } from "@angular/core";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import * as moment from "moment";
import { priceToY } from "src/app/Models/Annotations/Annotations";
import { Chart } from "src/app/Models/Chart";
import { PriceMark } from "src/app/Models/lcharts/src/model/price-scale";
import { DgHubClientService } from "../dg-hub-client.service";

declare var strikeService: any;

@Injectable({
  providedIn: "root",
})
export class StrikeService {
  public lcanvasLeft: number;
  public lcanvasTop: number;
  public strikes: Map<string, number> = new Map<string, number>();
  public subscribed: Map<string, string[]> = new Map<string, string[]>();
  public values: Map<string, string[]> = new Map<string, string[]>();
  public chart: Chart;
  public colorRamp:ColorTimeRow[] = DefaulColors;
  private _actionTypeLeft: StrikeActionType = StrikeActionType.PUT;
  public get actionTypeLeft(): StrikeActionType {
    return this._actionTypeLeft;
  }
  public set actionTypeLeft(value: StrikeActionType) {
    this._actionTypeLeft = value;
  }

  private _actionTypeRight: StrikeActionType = StrikeActionType.CALL;
  public get actionTypeRight(): StrikeActionType {
    return this._actionTypeRight;
  }
  public set actionTypeRight(value: StrikeActionType) {
    this._actionTypeRight = value;
  }

  private _selectedDateLeft = new Date();
  public get selectedDateLeft() {
    return this._selectedDateLeft;
  }
  public set selectedDateLeft(value) {
    this._selectedDateLeft = value;
  }

  private _selectedDateRight = new Date();
  public get selectedDateRight() {
    return this._selectedDateRight;
  }
  public set selectedDateRight(value) {
    this._selectedDateRight = value;
  }

  private _actionDayLeft: string;
  public get actionDayLeft(): string {
    return this._actionDayLeft;
  }
  public set actionDayLeft(value: string) {
    this._actionDayLeft = value;
  }

  private _actionDayRight: string;
  public get actionDayRight(): string {
    return this._actionDayRight;
  }
  public set actionDayRight(value: string) {
    this._actionDayRight = value;
  }


public colorRampUpdate(colors:ColorTimeRow[])
{
    this.colorRamp = colors;
    localStorage.setItem("rytmicColorRamp",JSON.stringify(this.colorRamp));
}


  constructor(private _hubservice: DgHubClientService) {

    var colors = localStorage.getItem("rytmicColorRamp");

    if(colors)
    {
      this.colorRamp = JSON.parse(colors);
    }


    DGStrikeServiceGlobal._init(this);

    strikeService = this;

    // this._hubservice.StrikeTick.subscribe((r) => {
    //   var labels = this.getByValue(this.subscribed, r.symbol);

    //   if (r.symbol == "E3DV2 P3840") {
    //     //console.log("E3DV2 P3840");
    //   }

    //   if (r.symbol == "E3DV2 C3840"&&r.bid > 0) {
    //     //console.log("E3DV2 C3840");
    //   }

    //   if (labels && labels.length > 0) {
    //     labels.forEach((t) => {
    //       var target = t.symbol;
    //       var id = target.replace(".", "_");

    //       if (r.bid > 0) {
    //           if (this.values.get(target)) {
    //             var vr = this.values.get(target);
    //             vr[t.index] = r.bid.toFixed(2);
    //             this.values.set(target, vr);
    //           } else {
    //             this.values.set(target, ['...', '...']);
    //             var vr = this.values.get(target);
    //             vr[t.index] = r.bid.toFixed(2);
    //             this.values.set(target, vr);
    //           }

    //       }
    //     });
    //   }
    // });

    // setInterval(() => {
    //   for (let key of Array.from(this.values.keys())) {
    //     var val = this.values[key];
    //     var id = key.replace(".", "_");
    //     //   //console.log(key);
    //     jQuery(`#strine_${id}`).text(val);
    //   }
    // }, 20);
  }

  public getByValue(map, searchValue): SymbolData[] {
    for (let [key, value] of map.entries()) {
      var found: string[] = value.filter((l) => {
        return l == searchValue;
      });

      if (found.length > 0) {
        var t: SymbolData[] = [];
        found.forEach((l) => {
          var index = value.indexOf(l);
          var p: SymbolData = {
            index: index,
            symbol: key,
          };
          t.push(p);
        });

        return t;
      }
    }
    return null;
  }

  public checkAndShowStrike(initVal: string) {
    ////console.log("STRIKE",initVal)
  }

  public setCanvasLocation() {
    if (!this.lcanvasLeft) {
      this.lcanvasLeft =
        $("#ist_price_canvas_0")[0].getBoundingClientRect().left +
        $(window)["scrollLeft"]();
    }

    if (!this.lcanvasTop) {
      this.lcanvasTop =
        $("#ist_price_canvas_0")[0].getBoundingClientRect().top +
        $(window)["scrollLeft"]();
    }
  }

  public updateCanvasLocation() {
    this.lcanvasLeft =
      $("#ist_price_canvas_0")[0].getBoundingClientRect().left +
      $(window)["scrollLeft"]();

    this.lcanvasTop =
      $("#ist_price_canvas_0")[0].getBoundingClientRect().top +
      $(window)["scrollLeft"]();
  }

  public newStrikes(marks: PriceMark[]) {
    return
    this.updateCanvasLocation();

    if (!this.chart || marks.length == 0) {
      return;
    }
    jQuery(".strike-click-wrapper").remove();
    jQuery(".strike-strike-wrapper").remove();
    marks.forEach((l) => {
      var id = l.label.replace(".", "_");
      let y = priceToY(Number(l.label), this.chart.chart);

      var style = `background-color:transparent;opacity:0.5;top: ${
        y + this.lcanvasTop - 10
      }px; left: ${
        this.lcanvasLeft - 20
      }px; width:50px; height:20px;font-size:12px;position:absolute;display:inline-block`;
      jQuery("body").append(
        `<div onclick="callStrikeJs('${l.label}','${y}')" id="${id}" style="${style}" class='strike-click-wrapper'></div>`
      );

      var value = this.strikes.get(l.label);
      if (value) {
        var lv = "...";
        if (this.values.get(l.label)) {
          lv = this.values.get(l.label)[0];
        }

        var rv = "...";
        if (this.values.get(l.label)) {
          rv = this.values.get(l.label)[1];
        }

        var styleStrike = `background-color:${this.colorRamp[0].color};top: ${Number(y) + this.lcanvasTop - 8}px; left: ${40 + this.lcanvasLeft}px; width:40px;color:#fff; height:20px;font-size:12px;position:absolute;display:inline-block`;
        var styleStrike_1 = `background-color:${this.colorRamp[0].color};top: ${ Number(y) + this.lcanvasTop - 8}px; left: ${85 + this.lcanvasLeft}px; width:40px;color:#fff; height:20px;font-size:12px;position:absolute;display:inline-block`;

        jQuery("body").append(
          `<div id="strine_${id}" style="${styleStrike}" class='strike-strike-wrapper'>${lv}</div>`
        );
        jQuery("body").append(
          `<div id="strine_${id}_1" style="${styleStrike_1}" class='strike-strike-wrapper'>${rv}</div>`
        );
      }
    });
  }

  public initStrikeSubscription(label, y) {
 //   if (!this.strikes.get(label)) {
      var id = label.replace(".", "_");

      this.strikes.set(label, label);
      //console.log("initStrikeSubscription", label);

      var styleStrike = `background-color:${this.colorRamp[0].color};top: ${Number(y) + this.lcanvasTop - 8}px; left: ${40 + this.lcanvasLeft}px; width:40px;color:#fff; height:20px;font-size:12px;position:absolute;display:inline-block`;
      var styleStrike_1 = `background-color:${this.colorRamp[0].color};top: ${ Number(y) + this.lcanvasTop - 8}px; left: ${85 + this.lcanvasLeft}px; width:40px;color:#fff; height:20px;font-size:12px;position:absolute;display:inline-block`;
      jQuery("body").append(
        `<div id="strine_${id}" style="${styleStrike}" class='strike-strike-wrapper'>...</div>`
      );
      jQuery("body").append(
        `<div id="strine_${id}_1" style="${styleStrike_1}" class='strike-strike-wrapper'>...</div>`
      );
      this.subscribeAction(label);
   // } else {
      // this._hubservice.removeSubscription( this.subscribed.get(label) ).then((l)=>{
      //   //console.log(l);
      //   this.subscribed.delete(label);
      //   this.strikes.delete(label)
      // })
   // }
  }

  public subscribeAction(label: string) {
    var symbolResolved = this.resolveSymbol(
      this.actionDayLeft,
      this.actionTypeLeft,
      label
    );
    var symbolResolved_1 = this.resolveSymbol(
      this.actionDayRight,
      this.actionTypeRight,
      label
    );
    var symbols = [symbolResolved, symbolResolved_1];
    // return;
    var symbol = symbolResolved;
    this._hubservice.NewStrikeSubscription(symbols[0]).then((l) => {
      this._hubservice.NewStrikeSubscription(symbols[1]).then((l) => {

        var s = this.subscribed.get(label);
        var z = this.values.get(label);;
        if(s&&s.length>0)
        {
          if(s[0]!=symbolResolved)
          {
              z[0]='...';
              var id = `#strine_${id}`
              jQuery(id).html("...");
          }
          if(s[1]!=symbolResolved_1)
          {
            z[1]='...';
            var id_1 = `#strine_${id}_1`
            jQuery(id_1).html("...");
          }

        }


        this.subscribed.set(label, symbols);
        //console.log(l);
      });
    });
  }

  public addEventLeft(type: string, event: MatDatepickerInputEvent<Date>) {
    //this.events.push(`${type}: ${event.value}`);
    this.selectedDateLeft = event.value;
    //console.log(event.value);
  }

  public addEventRight(type: string, event: MatDatepickerInputEvent<Date>) {
    //this.events.push(`${type}: ${event.value}`);
    this.selectedDateRight = event.value;
    //console.log(event.value);
  }

  public updatePositions() {
    if (!this.chart) {
      return;
    }
    //   return;
    jQuery(".strike-click-wrapper").remove();
    let keys = Array.from(this.strikes.keys());
    keys.forEach((m) => {
      var item = this.strikes.get(m);
      let y = priceToY(item, this.chart.chart);
      if (y > 0 && y < 600 && item > 100) {
        var style = `background-color:transparent;top: ${
          y + this.lcanvasTop
        }px; left: ${
          this.lcanvasLeft
        }px; width:30px; height:20px;font-size:12px;position:absolute;display:inline-block`;
        jQuery("body").append(
          `<div id="${m}" style="${style}" class='strike-click-wrapper'>${item}</div>`
        );
      }

      //jQuery(`#${m}`).css(style);
    });
  }

  public resolveSymbol(date: string, type: StrikeActionType, strike: string) {
    // var momentDate = moment(date);

    var check = moment(date, "YYYY/MM/DD");

    // if()
    // {

    // }
    var month = check.format("M");
    var day = check.format("D");
    var year = check.format("YYYY");

    var weekDay = check.day();
    var week = this.weekOfMonth(check);

    var weekDayStr = "";
    switch (weekDay) {
      case 0:
        weekDayStr = "W";
        break;
      case 1:
        weekDayStr = "A";
        break;
      case 2:
        weekDayStr = "B";
        break;
      case 3:
        weekDayStr = "C";
        break;
      case 4:
        weekDayStr = "D";
        break;
      case 5:
        weekDayStr = "W";
        break;
      case 6:
        weekDayStr = "W";
        break;
      case 7:
        weekDayStr = "W";
        break;
    }

    var monthStr = "";
    switch (Number(month)) {
      case 1:
        monthStr = "F";
        break;
      case 2:
        monthStr = "G";
        break;
      case 3:
        monthStr = "H";
        break;
      case 4:
        monthStr = "J";
        break;
      case 5:
        monthStr = "K";
        break;
      case 6:
        monthStr = "M";
        break;
      case 7:
        monthStr = "N";
        break;
      case 8:
        monthStr = "Q";
        break;
      case 9:
        monthStr = "U";
        break;
      case 10:
        monthStr = "V";
        break;
      case 11:
        monthStr = "X";
        break;
      case 12:
        monthStr = "Z";
        break;
    }

    var typeStr = "";
    switch (type) {
      case StrikeActionType.CALL:
        typeStr = "C";
        break;
      case StrikeActionType.PUT:
        typeStr = "P";
        break;
    }

    var strikeStr = strike.split(".")[0];

    var yearString = year[year.length - 1];

    var symbol = "";

    if (month == "9" && day == "30") {
      symbol = `ECESU230 ${typeStr}${strikeStr}`;
      return symbol;
    }

    if (week == 5) {
      symbol = `EW${monthStr}${yearString} ${typeStr}${strikeStr}`;
      return symbol;
    }

    if (weekDayStr != "W") {
      symbol = `E${week}${weekDayStr}${monthStr}${yearString} ${typeStr}${strikeStr}`;
      return symbol;
    } else {
      symbol = `E${weekDayStr}${week}${monthStr}${yearString} ${typeStr}${strikeStr}`;
      return symbol;
    }
  }

  public weekOfMonth(m) {
    var day = m.format("D");
    var mod = day % 7;
    var t = (day - mod) / 7;
    return mod != 0 ? t + 1 : t;
  }
}

export class DGStrikeServiceGlobal {
  private static _service: StrikeService;
  static _init(service: StrikeService) {
    DGStrikeServiceGlobal._service = service;
  }

  static strikeService(): StrikeService {
    return DGStrikeServiceGlobal._service;
  }
}

export enum StrikeActionType {
  CALL,
  PUT,
}

export interface SymbolData {
  symbol: string;
  index: number;
}

export enum SubscriptionDirection {
  LEFT,
  RIGHT,
}

export interface ColorTimeRow
{
  time:number,
  color:string,
}

export const DefaulColors:ColorTimeRow[]=
[
 {
  time:1,
  color:'#3d00ff'
 },
 {
  time:2,
  color:'#5912d9'
 },
 {
  time:3,
  color:'#7323b7'
 },
 {
  time:4,
  color:'#87319d'
 },
 {
  time:5,
  color:'#ad496a'
 },
 {
  time:6,
  color:'#c75a49'
 },
 {
  time:7,
  color:'#e86f1e'
 },
 {
  time:8,
  color:'#f87909'
 },
 {
  time:9,
  color:'#ff6800'
 },
 {
  time:10,
  color:'#ff5a00'
 },
 {
  time:11,
  color:'#ff5000'
 },
 {
  time:12,
  color:'#ff5200'
 },
 {
  time:13,
  color:'#ff4300'
 },
 {
  time:14,
  color:'#ff2d00'
 },
 {
  time:15,
  color:'#ff0200'
 },

];
